import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cold-calls-files',
  templateUrl: './cold-calls-files.component.html',
  styleUrls: ['./cold-calls-files.component.css']
})
export class ColdCallsFilesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/cold-calls-files/cold-calls-files.component.ts